var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"test"},[_c('img',{staticClass:"logo",attrs:{"src":"https://houseofdev.tech/assets/logo/house-of-dev-2.svg","alt":""}})])])}]

export { render, staticRenderFns }